'use es6';

import Immutable from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
var defaultState = Immutable.fromJS({
  goodToRefund: {},
  open: false,
  submitRefundError: null,
  submitRefundStatus: RequestStatusTypes.UNINITIALIZED
});
export default function refundModalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.REFUND_MODAL_OPENED:
      return state.merge({
        goodToRefund: action.payload,
        open: true,
        submitRefundStatus: RequestStatusTypes.UNINITIALIZED
      });

    case ActionTypes.DISMISSED_REFUND_MODAL:
      return defaultState;

    case ActionTypes.REFUND_SUBMITTED:
      if (action.error) {
        return state.merge({
          submitRefundError: action.payload,
          submitRefundStatus: RequestStatusTypes.FAILED
        });
      }

      return state.set('submitRefundStatus', RequestStatusTypes.PENDING);

    case ActionTypes.REFUND_SUBMITTED_SUCCESS:
      return state.set('submitRefundStatus', RequestStatusTypes.SUCCEEDED);

    default:
      return state;
  }
}